import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import AdminNavbar from "../components/admin/AdminNavbar";
import AdminSidebar from "../components/admin/AdminSidebar";

import "../style/admin-layout.css";

export default function AdminLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className="admin-layout">

      <AdminSidebar open={open} setOpen={setOpen} />

      <div className="admin-main">
        <AdminNavbar setOpen={setOpen} />
        <div className="admin-content">
          <Outlet />
        </div>
      </div>

    </div>
  );
}